// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoryChip_container__pclT9"};